import * as React from 'react';
import strings from '../../strings/strings.json';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Flex } from '../Elements';
import NavButton from 'components/buttons/NavButton';
import Button from 'components/buttons/Button';

type StepperButtonRowProps = {
    submitButtonTitle: string;
    submitButtonAria: string;
    buttonsDisabled?: boolean;
    previousButtonFunction?: Function;
    submitButtonFunction?: Function;
    submitting?: boolean;
    showPreviousButton?: boolean;
};

export default function StepperButtonRow({
    submitButtonTitle,
    submitButtonAria,
    buttonsDisabled,
    previousButtonFunction,
    submitButtonFunction,
    submitting,
    showPreviousButton = true,
}: StepperButtonRowProps): JSX.Element {
    const navigate = useNavigate();

    function buttonFunction() {
        if (previousButtonFunction) {
            previousButtonFunction();
            return;
        }
        navigate(-1);
    }

    return (
        <ButtonRow>
            {showPreviousButton && (
                <div>
                    <NavButton
                        title={strings.stepper.backButtonMobileTitle}
                        aria={strings.stepper.backButtonMobileAria}
                        onClick={buttonFunction}
                        back
                    />
                </div>
            )}
            <Button
                type={submitButtonFunction ? 'button' : 'submit'}
                title={submitButtonTitle}
                aria={submitButtonAria}
                onClick={submitButtonFunction ? () => submitButtonFunction() : undefined}
                submitting={submitting}
                fullwidth={false}
            />
        </ButtonRow>
    );
}

const ButtonRow = styled(Flex)`
    justify-content: space-between;
`;
